import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Table, Button } from 'virtues-bootstrap';
import { mapIndex } from 'utilities/ramda';
import { Link } from 'react-router-dom';

import s from './styles.module.scss';

const OrganizationsTable = ({ data }) => (
  <Paper>
    <Table striped>
      <thead>
        <tr>
          <td>Name</td>
          <td>Id</td>
          <td>Practitioners</td>
          <td />
        </tr>
      </thead>
      <tbody>
        {mapIndex(
          ({ name, id, practitioners }, index) => (
            <tr key={index}>
              <td>
                <strong>{name}</strong>
              </td>
              <td>
                <strong>{id}</strong>
              </td>
              <td className={s.site}>
                <div>
                  {mapIndex(practitioner => <div key={practitioner}>{practitioner}</div>)(
                    practitioners,
                  )}
                </div>
              </td>
              <td>
                <Button component={Link} to={`/sites/${id}`} variant="secondary">
                  Edit
                </Button>
              </td>
            </tr>
          ),
          data,
        )}
      </tbody>
    </Table>
  </Paper>
);

OrganizationsTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      practitioners: PropTypes.arrayOf(PropTypes.string).isRequired,
    }),
  ).isRequired,
};

export default OrganizationsTable;
